import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProducts } from '../../services/api';
import './PopularProducts.css';

function PopularProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const data = await getProducts();
        // For now, show all products or first 6
        setProducts(Array.isArray(data) ? data.slice(0, 6) : []);
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch products:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return (
      <section className="section popular-products">
        <div className="container">
          <div className="loading">
            <div className="spinner"></div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="section popular-products">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Popular Cheats</h2>
            <p className="section-subtitle">Check out what's working right now</p>
          </div>
          <div className="error-message">
            <p>No products available yet. Check back soon!</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section popular-products" id="products">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Popular Cheats</h2>
          <p className="section-subtitle">Check out what's working right now</p>
        </div>

        {products.length === 0 ? (
          <div className="no-products">
            <div className="placeholder-card">
              <div className="placeholder-image">
                <p>🎮</p>
              </div>
              <h3>Products Coming Soon</h3>
              <p>We're adding new products to the store. Check back shortly!</p>
            </div>
          </div>
        ) : (
          <div className="products-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}

        <div className="products-cta">
          <Link to="/products" className="btn btn-secondary">
            View All Products
          </Link>
        </div>
      </div>
    </section>
  );
}

function ProductCard({ product }) {
  return (
    <Link to={`/products/${product.id}`} className="product-card card">
      <div className="product-image">
        <div className="placeholder-image">
          <p>Image Coming Soon</p>
        </div>
        <span className="status-badge working">Undetected</span>
      </div>
      <div className="product-info">
        <h3 className="product-title">{product.title || product.name || 'Product'}</h3>
        <p className="product-description">
          {product.description ? 
            (product.description.length > 100 ? 
              product.description.substring(0, 100) + '...' : 
              product.description) : 
            'Premium gaming tool with all features included.'}
        </p>
        <div className="product-footer">
          <span className="product-price">${product.price || '0.00'}</span>
          <span className="product-link-text">View Details →</span>
        </div>
      </div>
    </Link>
  );
}

export default PopularProducts;
